import React, { useEffect, } from 'react';
import Proptypes from 'prop-types';
import {
  useDataModel,
  params,
  bool as boolType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { Card } from '@thd-olt-component-react/card';
import { Heading } from '@thd-olt-component-react/core-ui';
import { WhatWeOfferContent } from './WhatWeOfferContent';
import './what-we-offer.scss';
import { WhatWeOfferPlaceholder } from './what-we-offer-placeholder/WhatWeOfferPlaceholder';

export const WhatWeOffer = (props) => {
  const { itemId } = props;

  const options = {
    variables: {
      itemId
    }
  };

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('what-we-offer.ready'); }, []);

  const { error, loading, data } = useDataModel('product', options);

  if (!loading && (error || !data || !data.product?.info?.displayWhatWeOffer)) {
    return null;
  }
  const content = loading ? <WhatWeOfferPlaceholder /> : <WhatWeOfferContent />;

  return (
    <div className="what-we-offer">
      <Card noHide>
        {!loading && <Heading title="What We Offer" className="what-we-offer__header" underline />}
        {content}
        <Card.Content fade maxHeight="200px" title={!loading ? 'What We Offer' : 'Loading...'} underline>
          {content}
          <Card.Content.Overlay>
            {content}
          </Card.Content.Overlay>
        </Card.Content>
      </Card>
    </div>
  );
};

WhatWeOffer.propTypes = {
  itemId: Proptypes.string.isRequired
};

WhatWeOffer.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    info: shapeType({
      displayWhatWeOffer: boolType()
    })
  })
};